export default __webpack_public_path__ + "static/media/analytics.13a494f8.webp";